if (!customElements.get('swiper-collection')) {
  class SwiperCollection extends HTMLElement {
    connectedCallback() {
      this.swiperContainer = this.querySelector('.swiper')
      this.nextButton = this.querySelector('.swiper-button-next')
      this.prevButton = this.querySelector('.swiper-button-prev')

      if (typeof Swiper !== 'undefined') {
        this.initSwiper()
      } else {
        window.addEventListener('load', () => this.initSwiper(), { once: true })
      }
    }

    initSwiper() {
      if (!this.swiperContainer) return
      if (this.swiperContainer.swiper) return

      const enableDesktopSlider =
        this.getAttribute('data-enable-desktop-slider') === 'true'

      this.swiper = new Swiper(this.swiperContainer, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        centerInsufficientSlides: true,
        watchOverflow: true,
        navigation: {
          nextEl: this.nextButton,
          prevEl: this.prevButton,
        },
        breakpoints: enableDesktopSlider
          ? {
              768: { slidesPerView: 2, slidesPerGroup: 1, spaceBetween: 20 },
              1024: { slidesPerView: 3, slidesPerGroup: 1, spaceBetween: 24 },
            }
          : {
              768: {
                slidesPerView: 3,
                slidesPerGroup: 1,
                spaceBetween: 80,
                enabled: false,
              },
            },
      })
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy()
        this.swiper = null
      }
    }
  }

  customElements.define('swiper-collection', SwiperCollection)
}
